/**
 * Shared bounded-retry logic for the four error views (ErrorSession,
 * ErrorUserAuth, ErrorService, ErrorFallback). Reads two sessionStorage
 * keys set by main.js:
 *
 *   _errRetry             — attempt counter (bumped here, reset by main.js on
 *                           a fully successful bootstrap)
 *   _lastAuthErrorStatus  — HTTP status code of the last auth failure; when
 *                           it is 401/403 the retry is permanent-config kind
 *                           (whitelist misconfig, revoked token, ...) and we
 *                           don't waste attempts hitting the same wall.
 *
 * Auto-retry uses exponential backoff (2s → 4s → 8s) so transient blips get
 * a couple of quick shots without hammering the API on real outages. After
 * the budget is spent — or immediately for permanent errors — a manual
 * "Riprova" button appears so the user can force a retry once the operator
 * has fixed the config.
 */

const MAX_RETRIES = 3;

export default {
    data() {
        return {
            retryDisabled: false,
        };
    },
    mounted() {
        const count = parseInt(sessionStorage.getItem('_errRetry') || '0', 10) || 0;
        const lastStatus = parseInt(sessionStorage.getItem('_lastAuthErrorStatus') || '0', 10) || 0;
        const isPermanent = lastStatus === 401 || lastStatus === 403;

        if (isPermanent || count >= MAX_RETRIES) {
            this.retryDisabled = true;
            return;
        }

        sessionStorage.setItem('_errRetry', String(count + 1));

        // Exponential backoff: attempt 1 waits 2s, attempt 2 waits 4s,
        // attempt 3 waits 8s. Total worst case ≈ 14s before the manual
        // button takes over.
        const delayMs = Math.pow(2, count + 1) * 1000;
        this._retryTimer = setTimeout(() => {
            window.location.replace(window.location.href.split('#')[0]);
        }, delayMs);
    },
    beforeDestroy() {
        clearTimeout(this._retryTimer);
    },
    methods: {
        manualRetry() {
            sessionStorage.removeItem('_errRetry');
            sessionStorage.removeItem('_lastAuthErrorStatus');
            window.location.replace(window.location.href.split('#')[0]);
        },
    },
};
